<template>
    <div v-if="featureEnabled">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'XlinxFeature',

    props: {
        featureName: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            featureEnabled: false,
        };
    },

    watch: {
        featureName() {
            this.checkFeature();
        },
    },

    created() {
        this.checkFeature();
    },

    methods: {
        async checkFeature() {
            this.featureEnabled = await this.$feature.enabled(this.featureName);
        },
    },
};
</script>
